import React from 'react'
import { Images } from '../../../utils/imageConstants'
import type { FileWithKey } from '../types'

interface FileCardProps {
  fileWithKey: FileWithKey
  index: number
  getFileIcon: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string
  onRemove: (index: number) => void
}

const FileCard: React.FC<FileCardProps> = ({
  fileWithKey,
  index,
  getFileIcon,
  onRemove
}) => {
  return (
    <div 
      className={`statgpt-file-card ${fileWithKey.fileType === 'image' ? 'statgpt-file-card-image' : ''} ${fileWithKey.isUploading ? 'statgpt-file-card-uploading' : ''}`}
    >
      {fileWithKey.fileType === 'image' && fileWithKey.preview ? (
        <div className="statgpt-file-card-image-preview">
          <img src={fileWithKey.preview} alt={fileWithKey.file.name} />
          {fileWithKey.isUploading && (
            <div className="statgpt-file-card-loader">
              <div className="statgpt-file-card-spinner"></div>
            </div>
          )}
        </div>
      ) : (
        <div className="statgpt-file-card-icon">
          {fileWithKey.isUploading ? (
            <div className="statgpt-file-card-spinner"></div>
          ) : (
            getFileIcon(fileWithKey.fileType)
          )}
        </div>
      )}
      {fileWithKey.fileType !== 'image' && (
        <div className="statgpt-file-card-name">
          {fileWithKey.file.name}
        </div>
      )}
      <button
        className="statgpt-file-card-remove"
        onClick={() => onRemove(index)}
        aria-label="Remove file"
        disabled={fileWithKey.isUploading}
      >
        <img src={Images.close_dropdown_icon} alt="Remove" />
      </button>
    </div>
  )
}

export default FileCard

